import { accessKeys } from '../../types/AccessKeys';
import { Namespace } from '../../translation/namespace';

export const shortcuts = (t: (s: any) => string) => {
  return [
    {
      action: t(`${Namespace.glossary}:homePage`),
      shortcut: [accessKeys.homepage],
    },
    {
      action: t(`${Namespace.glossary}:editMode`),
      shortcut: [accessKeys.editMode],
    },
    {
      action: t(`${Namespace.glossary}:publish`),
      shortcut: [accessKeys.publish],
    },
    {
      action: t(`${Namespace.glossary}:depublish`),
      shortcut: [accessKeys.dePublish],
    },
    {
      action: t(`${Namespace.glossary}:deletePage`),
      shortcut: [accessKeys.delete],
    },
    {
      action: t(`${Namespace.glossary}:instantSearch`),
      shortcut: [accessKeys.search],
    },
    {
      action: t(`${Namespace.glossary}:personalAccessLibrary`),
      shortcut: [accessKeys.pal],
    },
    {
      action: t(`${Namespace.glossary}:help`),
      shortcut: [accessKeys.help],
    },
  ];
};
